import { Order, Vehicle } from '@esportal/portal-service';

export const hasDGTLabelInfo = (vehicle: Vehicle | Order | null | undefined): boolean => {
	if (!vehicle || !('vgedFuelCode' in vehicle)) {
		return false;
	}

	const { vgedFuelCode, vgedRegistrationDate } = vehicle;

	if (!vgedFuelCode || !vgedRegistrationDate) {
		return false;
	}

	const registrationDate = new Date(vgedRegistrationDate);

	if (Number.isNaN(registrationDate.getTime())) {
		return false;
	}

	switch (vgedFuelCode) {
		case 'GASOLINA':
			return registrationDate < new Date('2006-01-01');
		case 'DIESEL':
			return registrationDate < new Date('2015-09-01');
		default:
			return false;
	}
};
